import { render, staticRenderFns } from "./KickedOut.vue?vue&type=template&id=4bae3782&"
import script from "./KickedOut.vue?vue&type=script&lang=js&"
export * from "./KickedOut.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports